import React from 'react';

import SideBar from '../../partials/SideBar';
import SidebarHeader from '../../partials/SidebarHeader';

import ContentLoader from '../../../ContentLoader';
import MainHeader from './MainHeader';
import useStyles from './index.style';
import Footer from '../../partials/Footer';

import defaultContext from '../../../contextProvider/AppContextProvider/defaultContext';

import CmtHeaderMain from '../../../../../@coremat/CmtLayouts/Horizontal/Header/HeaderMain';
import CmtHeader from '../../../../../@coremat/CmtLayouts/Horizontal/Header';
import CmtVerticalLayout from '../../../../../@coremat/CmtLayouts/Vertical';

import VCmtSidebar from '../../../../../@coremat/CmtLayouts/Vertical/Sidebar';
import VCmtContent from '../../../../../@coremat/CmtLayouts/Vertical/Content';
import FichasTecnicasContent from '../../../../../@coremat/CmtLayouts/Vertical/ContentFt'
import VCmtFooter from '../../../../../@coremat/CmtLayouts/Vertical/Footer';
import { useLocation } from 'react-router-dom';
import HoverSidebar from '../../partials/HoverSidebar';

const verticalLayoutOptions = {
  headerType: defaultContext.headerType,
  footerType: 'fixed',
  sidebarType: defaultContext.sidebarType,
  isSidebarFixed: defaultContext.isSidebarFixed,
  isSidebarOpen: false,
  showTourOpt: true,
  showFooterOpt: true,
  miniSidebarWidth: 80,
  layoutStyle: defaultContext.layoutType,
  drawerBreakPoint: 'xl', //setea el breakpoint para que se esconda el drawer
  sidebarWidth: defaultContext.sidebarWidth,
};

const CustomLayout = ({ children }) => {
  const location = useLocation();
  const classes = useStyles();

  return (
    <CmtVerticalLayout
      className="verticalDefaultLayout"
      layoutOptions={verticalLayoutOptions}
      header={
        <CmtHeader className={classes.appHeaderDark}>
          <CmtHeaderMain>
            <MainHeader />
          </CmtHeaderMain>
        </CmtHeader>
      }
      sidebar={
        location.pathname.includes("/ft-") ?
          <VCmtSidebar>
            <SidebarHeader />
            <HoverSidebar />
          </VCmtSidebar>
          :
          <VCmtSidebar>
            <SidebarHeader />
            <SideBar />
          </VCmtSidebar>
      }
/*      footer={
        <VCmtFooter>
          <Footer />
        </VCmtFooter>
      }*/>
      {
        location.pathname.includes("/ft-") ?
          <FichasTecnicasContent>
            {children}
            <ContentLoader />
          </FichasTecnicasContent>
          :
          <VCmtContent>
            {children}
            <ContentLoader />
          </VCmtContent>
      }

    </CmtVerticalLayout>
  );
};

export default CustomLayout;
